import React from "react";
import constants from "../../constants";

export default function InstructionHooks() {
  const getTestType = (data) => {
    if (data.testtype === constants.libTypeIds.MCQ) {
      return "MCQ";
    } else if (
      data.testtype === constants.libTypeIds.CODING_SNIPPET
    ) {
      return "Coding Snippet";
    } else if (
      data.videoqn &&
      data.testtype === constants.libTypeIds.DESCRIPTIVE
    ) {
      return "Video";
    } else if (data.testtype === constants.libTypeIds.DESCRIPTIVE) {
      return "Descriptive";
    } else if (data.testtype === constants.libTypeIds.CODING_CHALLENGE) {
      return "Coding Challenge";
    } else {
      return "SQL";
    }
  };
  return { getTestType };
}
